import SimpleCard from "lib/components/common/simple-card";

import DashboardLayout from "lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { Image } from "react-bootstrap";
import { Container, Row, Col, Form, Card, Accordion } from 'react-bootstrap';
import time_control_image from "../../../assets/images/time-control-image.png";
import speed_control_image from "../../../assets/images/speed-control-image.png";
import stop_control_image from "../../../assets/images/stop-session-image.png";
import pressure_control_image from "../../../assets/images/pressure-control-image.png";


import {
  PiHouseLight,
  PiShoppingCartLight,
} from "react-icons/pi";

const breadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    label: "Patients Management",
    path: PAGE_ROUTES.ADMIN.PatientsManagement,
  },
  {
    label: "Consent Form",
    path: ''
  },
] as BreadcrumbItem[];


const AirpodConsentFormPage = () => {


  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>

      <Container className="py-5">

        <Row className="justify-content-center">
          <Col md={10} lg={12} className="p-0">
            <Card className="shadow">
              <Card.Header className="bg-primary text-white">
                <h2 className="mb-0">AirPod™ CONSENT FORM</h2>
              </Card.Header>
              <Card.Body className="p-4">
                <Form>
                  <h5 className=" text-primary mb-4">Please complete the following information prior to commencing an AirPod™ session.</h5>
                  <Row className="g-3 mb-4">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">FIRST NAME</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter first name"
                          className="border-dark"
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">LAST NAME</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter last name"
                          className="border-dark"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 mb-4">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">EMAIL</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter email address"
                          className="border-dark"
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">PHONE</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter phone number"
                          className="border-dark"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 mb-4">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold">DATE OF BIRTH</Form.Label>
                        <Form.Control
                          type="date"
                          className="border-dark"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="mb-4">
                    <h5 className="mb-3 text-primary">
                      CONTRAINDICATIONS AND CONSENT FORM
                    </h5>
                    <p className="text-muted mb-4">
                      The following information is provided to assist you in determining if you can enjoy an AirPod session today.
                    </p>

                    <Accordion className="mb-4">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="fw-bold">
                          ABSOLUTE CONTRAINDICATIONS
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="list-unstyled mb-3">
                            <li>• Pneumothorax, Pulmonary hyper expansion</li>
                            <li>• Eardrum perforation</li>
                          </ul>
                          <div className="bg-light p-3 rounded">
                            <small className="text-muted">
                              NOTE: One of the factors to take into consideration before treating a patient in HBO is the interaction of prescription medicines with a mild hyperbaric experience. Most of them are indicated, some require monitoring others are contraindicated and some relatively contraindicated, as the case may be. Pressure in the chamber (1.3 ATA) has no dangerous effects to be avoided or minimized, except for the contraindications shown in this manual.
                            </small>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header className="fw-bold">
                          RELATIVE CONTRAINDICATIONS
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="text-muted mb-3">
                            Any of these occurrences may disqualify the HBO candidate subject to prior evaluation and urgency:
                          </p>

                          <Row>
                            <Col md={6}>
                              <ul className="list-unstyled">
                                <li>1. Asthma.</li>
                                <li>2. Congenital sperocytosis.</li>
                                <li>3. The use of any of these drugs:</li>
                                <ul>
                                  <li>• Cisplatinum.</li>
                                  <li>• Disulfiram (Antabuse).</li>
                                  <li>• Doxorubicin.</li>
                                  <li>• Adriamicina.</li>
                                  <li>• Bleomycina.</li>
                                </ul>
                                <li>4. Emphysema with CO2 retention.</li>
                                <li>5. Fever (38.5°C), Colds, flu symptoms.</li>
                                <li>6. Records of medium ear problems or surgery</li>
                                <li>7. Convulsions.</li>
                              </ul>
                            </Col>
                            <Col md={6}>
                              <ul className="list-unstyled">
                                <li>8. Optic Neuritis, Optic barotraumas.</li>
                                <li>9. Pregnancy.</li>
                                <li>10. Airways diseases, Blocked ear canals, Blocked Sinuses.</li>
                                <li>11. Viral infections.</li>
                                <li>12. Excessive CO Exposure.</li>
                                <li>13. Decompression sickness.</li>
                                <li>14. Recent Alcohol consumption.</li>
                                <li className="mt-2">Drugs continued:</li>
                                <ul>
                                  <li>• Sulfamylon.</li>
                                  <li>• Amphetamines.</li>
                                  <li>• Nicorette-Nicoderm.</li>
                                  <li>• Narcotic analgesics.</li>
                                  <li>• Steroids.</li>
                                </ul>
                              </ul>
                            </Col>
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <div className="mb-4 p-3 border rounded">
                      <h6 className="fw-bold text-primary mb-3">MEDICATIONS</h6>
                      <p className="text-muted mb-3">
                        mHBOT may enhance the effectiveness or increase the metabolism (decrease the effectiveness) of any medication you are taking.
                      </p>
                      <div className="bg-warning bg-opacity-10 p-3 rounded mb-3">
                        <small className="text-dark fw-bold">
                          PLEASE CHECK WITH YOUR PHYSICIAN PRIOR TO YOUR AIRPOD SESSION TO OBTAIN APPROVAL.
                        </small>
                      </div>
                    </div>

                    <div className="mb-4">
                      <h6 className="fw-bold text-primary mb-3">MEDICAL QUESTIONNAIRE</h6>

                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have any difficulties clearing your ears when swimming or flying?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="ears" />
                              <Form.Check inline type="radio" label="NO" name="ears" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Are you pregnant?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="pregnant" />
                              <Form.Check inline type="radio" label="NO" name="pregnant" />
                              <Form.Check inline type="radio" label="NOT APPLICABLE" name="pregnant" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Are you prone to experience seizures? Do you experience epileptic seizures?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="seizures" />
                              <Form.Check inline type="radio" label="NO" name="seizures" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have compressive brain lesions or suspect that compressive brain lesions are an issue?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="brainLesions" />
                              <Form.Check inline type="radio" label="NO" name="brainLesions" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you suffer from claustrophobia or confinement anxiety?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="claustrophobia" />
                              <Form.Check inline type="radio" label="NO" name="claustrophobia" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Are you sensitive to any chemicals or perfumes?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="chemicals" />
                              <Form.Check inline type="radio" label="NO" name="chemicals" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Have you been diagnosed with emphysema?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="emphysema" />
                              <Form.Check inline type="radio" label="NO" name="emphysema" />
                            </div>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have a pacemaker?
                              <small className="text-muted d-block">(Please check with your Physician prior to your AirPod session.)</small>
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="pacemaker" />
                              <Form.Check inline type="radio" label="NO" name="pacemaker" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have a head cold, sinus or other condition that makes it difficult to equalise your ears?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="sinus" />
                              <Form.Check inline type="radio" label="NO" name="sinus" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have, or suspect you have, a Pneumothorax (collapsed lung)?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="pneumothorax" />
                              <Form.Check inline type="radio" label="NO" name="pneumothorax" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you have diabetes or are you insulin dependent?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="diabetes" />
                              <Form.Check inline type="radio" label="NO" name="diabetes" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Do you currently have a serious illness?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="illness" />
                              <Form.Check inline type="radio" label="NO" name="illness" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Are you a long term smoker?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="smoker" />
                              <Form.Check inline type="radio" label="NO" name="smoker" />
                            </div>
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                              Are you asthmatic?
                            </Form.Label>
                            <div>
                              <Form.Check inline type="radio" label="YES" name="asthmatic" />
                              <Form.Check inline type="radio" label="NO" name="asthmatic" />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    <div className="mb-4 p-3 border rounded bg-light">
                      <h6 className="fw-bold text-primary mb-3">PRECAUTIONARY CONDITIONS</h6>
                      <p className="text-muted mb-0">
                        HBOT may still be possible but requires medical clearance or a modified protocol if you have: upper respiratory or sinus infections, history of lung surgery or chest trauma, asthma, congestive heart failure, uncontrolled diabetes, implanted medical devices (pacemakers, insulin pumps, cochlear implants), seizures controlled with medication, or if you are pregnant and considering treatment.
                      </p>
                    </div>

                    <div className="mb-4 p-3 border rounded bg-light">
                      <h6 className="fw-bold text-primary mb-3">POTENTIAL RISKS & SIDE EFFECTS</h6>
                      <p className="text-muted mb-0">
                        While generally safe when performed correctly, HBOT may cause temporary ear discomfort, sinus pressure,
                        fatigue, mild dizziness, or claustrophobia. Rare risks include oxygen toxicity, middle ear barotrauma, and
                        changes in vision.
                      </p>
                    </div>
                  </div>


                </Form>

                <div className="mb-5">
                  <h4 className="text-primary mb-4">HOW TO ADJUST THE AIRPOD DURING A SESSION</h4>

                  <Row className="mb-4">
                    <Col md={6}>
                      <div className="border rounded p-3 text-center mb-3">
                        <h6 className="fw-bold">BUTTON TO PRESS TO CHANGE THE TIME</h6>
                        <div className="bg-light rounded p-4 mt-2">
                          <Image
                            src={time_control_image}
                            alt="Time Control Button"
                            className="img-fluid rounded"
                            style={{ width: "100%", height: "auto", objectFit: "contain" }}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="border rounded p-3 text-center mb-3">
                        <h6 className="fw-bold">BUTTON TO PRESS TO CHANGE THE SPEED</h6>
                        <div className="bg-light rounded p-4 mt-2">
                          <Image
                            src={speed_control_image}
                            alt="Speed Control Button"
                            className="img-fluid rounded"
                            style={{ width: "100%", height: "auto", objectFit: "contain" }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md={6}>
                      <div className="border rounded p-3 text-center mb-3">
                        <h6 className="fw-bold">BUTTON TO PRESS TO STOP THE SESSION</h6>
                        <div className="bg-light rounded p-4 mt-2">
                          <Image
                            src={stop_control_image}
                            alt="Stop Control Button"
                            className="img-fluid rounded"
                            style={{ width: "100%", height: "auto", objectFit: "contain" }}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="border rounded p-3 text-center mb-3">
                        <h6 className="fw-bold">BUTTON TO PRESS TO CHANGE THE PRESSURE</h6>
                        <div className="bg-light rounded p-4 mt-2">
                          <Image
                            src={pressure_control_image}
                            alt="Pressure Control Button"
                            className="img-fluid rounded"
                            style={{ width: "100%", height: "auto", objectFit: "contain" }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                </div>

                <Accordion className="mb-5">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <strong>OTIC (EAR) BAROTRAUMA & EAR HEALTH</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <h6 className="fw-bold mb-3">Equalization Techniques:</h6>
                      <ul className="mb-4">
                        <li>You can assist the equalization process by yawning, chewing, swallowing, working your jaw side to side and up and down, turning the head side to side and ear to shoulder.</li>
                        <li>In general, doing whatever assists you being comfortable when taking off and landing in a plane may be most effective for you.</li>
                        <li>Continue to do this as needed for the duration of pressurization and depressurization.</li>
                        <li>When the AirPod reaches full pressure and again when the AirPod is at normal pressure, there should be no additional pressure in the ears.</li>
                      </ul>

                      <h6 className="fw-bold text-danger mb-3">Important Safety Information:</h6>
                      <ul className="mb-4">
                        <li>If you are unable to equalize ear pressure, and if you experience pain in one or both ears, it is critical that you reduce the pressure setting on the Control Panel or press the Safety Release Valve to end the AirPod session.</li>
                        <li>You can adjust the pressurization or depressurization process to eliminate discomfort - refer User Instructions above.</li>
                        <li>If you are unable to equalize the pressure in your ears the session will be immediately concluded.</li>
                        <li>If pain persists beyond the visit, we recommend that you consult your physician to alleviate the pain before another visit.</li>
                      </ul>

                      <div className="bg-warning bg-opacity-10 p-3 rounded">
                        <h6 className="fw-bold mb-2">EAR, SINUS, THROAT CONGESTION, HEAD COLDS, VIRUS OR PRIOR TRAUMA TO THE EARS</h6>
                        <ul className="mb-0">
                          <li>It is recommended that you reschedule your AirPod session if you are experiencing any of these conditions.</li>
                          <li>Discomfort from these conditions may occur.</li>
                        </ul>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <strong>PULMONARY HYPEREXPANSION</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>This condition is very rare during AirPod sessions.</li>
                        <li className="fw-bold text-danger">Holding your breath during decompression must be avoided as it could lead to expansion of the air in your lungs and damage to the lung tissues.</li>
                        <li>In the highly unlikely event of an unexpected rapid decompression, it is vital that you exhale immediately.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <strong>PREGNANCY</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="fw-bold text-danger mb-0">
                        • High pressure oxygen is not allowed during pregnancy.
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <strong>SEIZURES</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>If you are seizure prone, please ensure you make our staff aware prior to any visit.</li>
                        <li>If you experience a seizure, our procedure is to call emergency services, remove the patient from the chamber and make the individual as comfortable as possible.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <strong>PNEUMOTHORAX</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>High pressure oxygen sessions are contraindicated for an existing pneumothorax (collapsed lung).</li>
                        <li>If you have a Pneumothorax or suspect that a Pneumothorax is an issue, you will NOT be able to use the AirPod until a clearance from your Physician is provided in writing.</li>
                        <li>If you have experienced a pneumothorax in the past and have already been "cleared from your doctor" to resume normal activity, please present a written confirmation from your Physician advising you are able to proceed with the AirPod session.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      <strong>COMPRESSIVE BRAIN LESIONS – SUBDURAL HEMATOMA, INTERCRANIAL HEMATOMA</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>If you have compressive brain lesions or suspect that compressive brain lesions are an issue, you will not be able to use the AirPod until you receive clearance from your Physician.</li>
                        <li>If you have experienced compressive brain lesions in the past and have already been "cleared from your doctor" to resume normal activity, please provide a written confirmation from your Physician so that you can commence the AirPod session.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="6">
                    <Accordion.Header>
                      <strong>DIABETES / INSULIN DEPENDENT</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>Insulin dependency may result in a drop in blood sugar while in the chamber.</li>
                        <li>If you experience or anticipate this episode, immediately communicate to the staff so that your session can be stopped.</li>
                        <li>If you are insulin dependent, please ensure you:
                          <ul>
                            <li>Take a blood sugar reading prior to your session (if below 150, you must have a snack prior to treatment) and again after your treatment (if below 150, you must have a snack prior to leaving).</li>
                            <li>Take a protein bar, or item you use to manage this condition, into the capsule with you.</li>
                          </ul>
                        </li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      <strong>SENSITIVITY TO CHEMICALS (MCS) / ODORS / ALLERGY</strong>
                    </Accordion.Header>
                    <Accordion.Body>
                      <ul>
                        <li>Avoid wearing heavy colognes as the smells may linger in the capsule and have an adverse effect on another patient.</li>
                        <li>If you experience adverse sensitivity or have allergies that may become aggravated while in the chamber, please let our staff know prior to your visit, or as soon as possible when in the chamber, so we can take action to assure your comfort or conclude the session.</li>
                        <li>If your sensitivities persist, we recommend you consult your physician in order to alleviate the underlying condition before your next visit.</li>
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <div className="border border-2 rounded p-4 bg-light">
                  <h4 className="text-primary mb-4">INFORMED CONSENT & LIABILITY WAIVER</h4>
                  <p className="mb-4">
                    I confirm that I have read and understood the information above, fully disclosed my medical history,
                    had the opportunity to ask questions, and understand the potential risks. I voluntarily consent to
                    undergo Hyperbaric Oxygen Therapy and release Heal Wellness Clinic, its practitioners, and staff
                    from liability for any adverse effects, provided all safety protocols are followed.
                  </p>

                  <Row className="mb-3">
                    <Col md={8}>
                      <div className="border-bottom pb-1 mb-2">
                        <strong>Name (please print)</strong>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6}>
                      <div className="border-bottom pb-1 mb-2">
                        <strong>Signature</strong>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="border-bottom pb-1 mb-2">
                        <strong>Date</strong>
                      </div>
                    </Col>
                  </Row>
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>

      </Container>
    </DashboardLayout>
  );
};

export default AirpodConsentFormPage;